import * as React from 'react';
import cn from 'classnames';
import * as styles from './styles.css';

import { handleLinkClick } from '../../../../utils/handleLinkClick';

export interface IPaginationItemProps {
  isActive?: boolean;
  /** Ссылка на страницу — чтобы поисковый бот мог обойти пагинацию. Без неё элемент рендерится без ссылки */
  href?: string;

  onClick?(): void;
}

export const PaginationItem: React.FC<IPaginationItemProps & React.PropsWithChildren> = props => {
  const className = cn(styles['container'], {
    [styles['container-active']]: props.isActive,
  });
  const content = <span className={styles['content']}>{props.children}</span>;

  if (props.href) {
    return (
      <a
        data-testid="pagination-item"
        className={className}
        href={props.href}
        onClick={event => handleLinkClick(event, props.onClick)}
      >
        {content}
      </a>
    );
  }

  return (
    <div data-testid="pagination-item" className={className} onClick={props.onClick}>
      {content}
    </div>
  );
};

PaginationItem.displayName = 'PaginationItem';
